module.exports = __webpack_public_path__ + "static/media/deskspace.8784cb96.jpg";